import { CardFooterLinks } from '../../../components/molecules/Card/CardFooter';
import { mediaDir } from '../../../appolloConfig';
import { AllFormationsAndTypesQuery } from '../../../graphql/generated/graphql';
import {
  FormationContent,
  FormationsType
} from '../../../types/formation/formations.def';
import { getRessourceTypeInfo } from '../../../theme/ressourceTypeInfo';

export const getFormationCardLinks = (
  entry: Omit<FormationContent, 'reservedToProf' | 'formation_type' | 'id'>
): CardFooterLinks[] => {
  const links: CardFooterLinks[] =
    (entry?.ressources &&
      entry?.ressources?.map(m => ({
        href: m.lien ?? (m.media && mediaDir + m.media[0]?.url),
        icon: getRessourceTypeInfo(m.type.nom).icon,
        text: m.titre,
        color: getRessourceTypeInfo(m.type.nom).color,
        variant: 'ressource'
      }))) ||
    [];
  return [...links];
};

export const getFormationsTypesFromQuery: (
  formationsType: AllFormationsAndTypesQuery['findFormationTypeWithRelatedFormations']
) => FormationsType[] = formationsType => {
  if (!formationsType || formationsType.length < 1) return [];
  return formationsType.map(p => ({
    id: p.id,
    name: p.name
  }));
};
